import { Suspense } from 'react';
import { anyCampaignItem } from 'assets/js/pages/engage/workflows/components/CampaignSelect';
import * as NodeBadges from 'assets/js/pages/engage/workflows/components/NodeBadges';
import { useSavedCampaigns } from 'assets/js/pages/engage/workflows/hooks/useSavedCampaigns';

const CAMPAIGN_BADGE_LIMIT = 4;

interface CampaignBadgesProps {
    campaigns: string[];
}
const CampaignBadges = ({ campaigns }: CampaignBadgesProps) => {
    const { data: hydratedCampaigns } = useSavedCampaigns(campaigns);
    const isAnyCampaignSelected = campaigns.length === 1 && campaigns[0] === anyCampaignItem.id;

    if (isAnyCampaignSelected) {
        return (
            <NodeBadges.Badge>
                From <span className="text-gray-900">any campaign</span>
            </NodeBadges.Badge>
        );
    }

    return hydratedCampaigns.length >= CAMPAIGN_BADGE_LIMIT ? (
        <NodeBadges.Badge>
            From <span className="text-gray-900">{hydratedCampaigns.length} campaigns</span>
        </NodeBadges.Badge>
    ) : (
        <NodeBadges.Badge>
            From{' '}
            <span className="text-gray-900">
                {hydratedCampaigns
                    .slice(0, 3)
                    .map(c => c.label)
                    .join(', ')}
            </span>
        </NodeBadges.Badge>
    );
};

const WrappedCampaignBadges = (props: CampaignBadgesProps) => {
    return (
        <Suspense fallback={null}>
            <CampaignBadges {...props} />
        </Suspense>
    );
};

export { WrappedCampaignBadges as CampaignBadges };
